export class PasswordResetResponse {
    ssprLink: string;
    code: number;
    developerMessage: string;
    message: string;
    status: number;
}
